import { useState } from 'react';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';

import ComponentModal from '../../component-modal/component-modal.component';
import ShippingOptionDisplay from '../../../shipping/shipping-options/display/shipping-options-display.components';

import {
  ColumnContainer,
  Subtitle,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow
} from '../../../../styles/component.styles';

const ShippingOptionsTable = ({ 
  options = [],
  getOptions = async () => {},
  sortKey = '',
  setSortKey = () => {},
  sortDirection = '',
  setSortDirection = () => {},
  reloadTable = async () => {} 
}) => {
  const [ showDisplay, setShowDisplay ] = useState(false);
  const [ currentShippingOption, setCurrentShippingOption ] = useState({});

  const sortColumn = async (key) => {
    if (key === sortKey) {
      if (sortDirection === 'ASC') {
        setSortDirection('DESC');
        return await reloadTable(true);
      }
      if (sortDirection === 'DESC') {
        setSortDirection('');
        return await reloadTable(true);
      }
      setSortDirection('ASC');
      return await reloadTable(true);
    } else {
      setSortKey(key);
      setSortDirection('ASC');
      return await reloadTable(true);
    }
  };

  const openDisplay = (option) => {
    setCurrentShippingOption(option);
    setShowDisplay(true)
  }

  return (
    <ColumnContainer>
      <ComponentModal
        isOpen={showDisplay}
        onClose={() => setShowDisplay(false)}
      >
        <ShippingOptionDisplay
          option={currentShippingOption} 
          getOptions={getOptions} 
          setShowDisplay={setShowDisplay} 
        />
      </ComponentModal>
      {options.length === 0 ? (
        <Subtitle>No Shipping Options To Display</Subtitle>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead cursor={'pointer'} onClick={() => sortColumn('label')}>
                <ColumnContainer flexDirection={'row'}>
                  Label
                  {sortKey === 'label' && sortDirection === 'ASC' ? (
                    <FaAngleUp />
                  ) : sortKey === 'label' && sortDirection === 'DESC' ? (
                    <FaAngleDown />
                  ) : (
                    <ColumnContainer minHeight={'1em'} minWidth={'1em'} />
                  )}
                </ColumnContainer>
              </TableHead>
              <TableHead>Provider</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Price</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {options.map((option, index) => (
              <TableRow key={index} cursor={'pointer'} onClick={() => openDisplay(option)}>
                <TableData>{option.label}</TableData>
                <TableData>{option.ShippingProvider?.name || '—'}</TableData>
                <TableData>{option.ShippingType?.name || '—'}</TableData>
                <TableData>${(option.price / 100).toFixed(2)}</TableData>
                <TableData>{option.active ? 'Active' : 'Inactive'}</TableData>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </ColumnContainer>
  );
};

export default ShippingOptionsTable;